var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/i18n-runtime/index.ts
var i18n_runtime_exports = {};
__export(i18n_runtime_exports, {
  CultureCodes: () => CultureCodes,
  Cultures: () => Cultures,
  CulturesInTheirLanguages: () => CulturesInTheirLanguages,
  ICUMessageFormatter: () => ICUMessageFormatter,
  PseudoCultures: () => PseudoCultures,
  isCulture: () => isCulture,
  isPseudoCulture: () => isPseudoCulture
});
module.exports = __toCommonJS(i18n_runtime_exports);

// src/i18n-runtime/icu-message-formatter.ts
var import_intl_messageformat = __toESM(require("intl-messageformat"));
var import_icu_messageformat_parser = require("@formatjs/icu-messageformat-parser");
var parser = __toESM(require("@formatjs/icu-messageformat-parser"));
var import_fast_memoize = __toESM(require("fast-memoize"));
var import_icu_skeleton_parser = require("@formatjs/icu-skeleton-parser");
var formatters = {
  getNumberFormat: (0, import_fast_memoize.default)(
    (locale, opts) => {
      if (locale === "es-ES") {
        opts = opts ?? {};
        if (opts.useGrouping === void 0) {
          opts.useGrouping = true;
        }
      }
      return new Intl.NumberFormat(locale, opts);
    }
  ),
  getDateTimeFormat: (0, import_fast_memoize.default)(
    (locale, opts) => new Intl.DateTimeFormat(locale, opts)
  ),
  getPluralRules: (0, import_fast_memoize.default)((locale, opts) => new Intl.PluralRules(locale, opts))
};
function convertNumberSkeletonToNumberFormatOptionsWithCustomOverrides(elem, args) {
  const tokens = elem.style.tokens;
  const value = args && args[elem.value];
  let result = (0, import_icu_skeleton_parser.parseNumberSkeleton)(tokens);
  for (const token of tokens) {
    switch (token.stem) {
      case "cs-compact-precise" /* CompactPrecise */:
        if (value) {
          const val = Number(value);
          if (val < 1e3 && val > -1e3) {
            result.minimumFractionDigits = 2;
            result.maximumFractionDigits = 2;
          } else {
            result.notation = "compact";
            result.compactDisplay = "short";
            result.minimumFractionDigits = 0;
            result.maximumFractionDigits = 1;
          }
        }
        break;
      case "cs-precise-integer" /* PreciseInteger */:
        result.minimumFractionDigits = 0;
        result.maximumFractionDigits = 0;
        break;
      case "cs-max-fraction-digits" /* MaxFractionDigits */:
        result.maximumFractionDigits = token.options[0];
        break;
      case "cs-min-fraction-digits" /* MinFractionDigits */:
        result.minimumFractionDigits = token.options[0];
        break;
      case "cs-scale" /* Scale */:
        if (value) {
          args[elem.value] = Number(value) * Number(token.options[0]);
        }
        break;
      case "cs-currency-display" /* CurrencyDisplay */:
        result.currencyDisplay = token.options[0];
        break;
    }
  }
  return result;
}
var runtimeParsingTokens = (t) => t.stem === "cs-compact-precise" /* CompactPrecise */ || t.stem === "cs-scale" /* Scale */;
function getCustomNumberFormats(template, args, idGenerator) {
  function traverseArray(elems, data2) {
    for (const elem of elems) {
      if (elem.type === import_icu_messageformat_parser.TYPE.number && elem.style && elem.style.tokens) {
        const result = convertNumberSkeletonToNumberFormatOptionsWithCustomOverrides(
          elem,
          args
        );
        const guidFormat = idGenerator();
        data2.numberFormats[`customFormat${guidFormat}`] = result;
        if (!data2.runtimeParsing && elem.style.tokens.filter(runtimeParsingTokens).length) {
          data2.runtimeParsing = true;
        }
        elem.style = `customFormat${guidFormat}`;
      }
      if (elem.type === import_icu_messageformat_parser.TYPE.select) {
        for (const option of Object.values(elem.options)) {
          traverseArray(option.value, data2);
        }
      }
    }
  }
  const parsedElements = parser.parse(
    template,
    {
      formatters,
      ignoreTag: true,
      requiresOtherClause: false
    }
    /* !! */
  );
  const data = { numberFormats: {}, runtimeParsing: false };
  traverseArray(parsedElements, data);
  return { parsedElements, data };
}
var ICUMessageFormatter = class {
  formatter;
  template;
  runtimeNumberParsing = false;
  currentCustomFormatId = 0;
  idGenerator = () => {
    return () => this.currentCustomFormatId++;
  };
  constructor(template, culture) {
    this.formatter = this.generateFormatterWithCustomFormats(template, culture);
    this.template = template;
  }
  generateFormatterWithCustomFormats(template, culture, args) {
    try {
      const {
        data: { numberFormats, runtimeParsing },
        parsedElements
      } = getCustomNumberFormats(template, args, this.idGenerator());
      this.runtimeNumberParsing = runtimeParsing;
      const customFormats = Object.keys(numberFormats).length ? { number: numberFormats } : void 0;
      return new import_intl_messageformat.default(parsedElements, culture, customFormats, {
        formatters,
        ignoreTag: true
      });
    } catch (e) {
      console.error(
        `Failed to create formatter for "${template}" and culture\xA0${culture}`
      );
      throw e;
    }
  }
  format(args = {}) {
    let formatter = this.formatter;
    const { locale: culture } = this.formatter.resolvedOptions();
    if (this.runtimeNumberParsing) {
      formatter = this.generateFormatterWithCustomFormats(
        this.template,
        culture,
        args
      );
    }
    const argNames = this.getArguments(formatter).map(
      (arg) => arg.name
    );
    if (new Set(Object.keys(args)) !== new Set(argNames)) {
      args = argNames.reduce((accum, k) => {
        accum[k] = args[k] === void 0 ? null : args[k];
        return accum;
      }, {});
    }
    return formatter.format(args);
  }
  getArguments(formatter) {
    function traverseArray(ast, args) {
      for (const elem of ast) {
        traverseElem(elem, args);
      }
      return args;
    }
    function traverseElem(elem, args) {
      if ((0, import_icu_messageformat_parser.isLiteralElement)(elem) || (0, import_icu_messageformat_parser.isPoundElement)(elem)) {
        return args;
      }
      let arg;
      if (elem.value in args) {
        arg = args[elem.value];
      } else {
        let type = "string";
        if ((0, import_icu_messageformat_parser.isNumberElement)(elem)) {
          type = "number";
        } else if ((0, import_icu_messageformat_parser.isDateElement)(elem) || (0, import_icu_messageformat_parser.isTimeElement)(elem)) {
          type = "Date";
        }
        arg = { name: elem.value, type, optional: false };
        args[elem.value] = arg;
      }
      if ((0, import_icu_messageformat_parser.isSelectElement)(elem) || (0, import_icu_messageformat_parser.isPluralElement)(elem)) {
        let optionElem;
        optionElem = (0, import_icu_messageformat_parser.isSelectElement)(elem) ? elem : elem;
        const keys = [];
        for (const [key, option] of Object.entries(optionElem.options)) {
          keys.push(key);
          traverseArray(option.value, args);
        }
        if ((0, import_icu_messageformat_parser.isPluralElement)(elem)) {
          arg.type = "number";
        } else {
          if (keys.length === 2 && (keys.includes("false") || keys.includes("true"))) {
            arg.type = "boolean";
          } else if (arg.name === "currency") {
            arg.type = "ConsumerCurrency";
          } else {
            arg.type = keys.map((key) => `"${key}"`).join(" | ");
            arg.optional = "other" in optionElem.options;
          }
        }
      }
      return args;
    }
    return Object.values(traverseArray(formatter.getAst(), {}));
  }
  get type() {
    const args = this.getArguments(this.formatter);
    const optional = args.reduce((v, arg) => v && arg.optional, true);
    return [
      optional ? "(args?:" : "(args:",
      " {",
      args.map((arg) => `${arg.name}${arg.optional ? "?" : ""}: ${arg.type}`).join(", "),
      "}) => string"
    ].join("");
  }
  get typeImpl() {
    const args = this.getArguments(this.formatter);
    const optional = args.reduce((v, arg) => v && arg.optional, true);
    let argType = "{ " + args.map((arg) => `${arg.name}${arg.optional ? "?" : ""}: ${arg.type}`).join(", ") + " }";
    if (optional) argType = argType + " | undefined";
    return `createFormat<${argType}>(${JSON.stringify(this.template)})`;
  }
  get ast() {
    return this.formatter.getAst();
  }
  get args() {
    const args = this.getArguments(this.formatter);
    return args;
  }
};

// src/i18n-runtime/types/cultures.ts
var Cultures = {
  EnglishCanada: "en-CA",
  EnglishUnitedKingdom: "en-GB",
  EnglishUnitedStates: "en-US",
  EnglishAustralia: "en-AU",
  FrenchCanada: "fr-CA",
  FrenchFrance: "fr-FR",
  SpanishSpain: "es-ES",
  GermanGermany: "de-DE",
  DutchNetherlands: "nl-NL",
  ItalianItaly: "it-IT",
  PortuguesePortugal: "pt-PT",
  SpanishMexico: "es-MX",
  SpanishLatinAmerica: "es-419",
  StretchEnglish: "en-ZW",
  MicroCodeEnglish: "en-ZA",
  CroatianCroatian: "hr-HR",
  CzechCzech: "cs-CZ",
  DanishDanish: "da-DK",
  FinnishFinish: "fi-FI",
  HungarianHungarian: "hu-HU",
  NorwegianBokmal: "nb-NO",
  NorwegianNynorsk: "nn-NO",
  PolishPolish: "pl-PL",
  SlovakSlovak: "sk-SK",
  SwedishSweden: "sv-SE",
  SimplifiedChinese: "zh-CN",
  JapaneseJapan: "ja-JP"
};
var CultureCodes = Object.values(Cultures);
var CulturesInTheirLanguages = /* @__PURE__ */ ((CulturesInTheirLanguages2) => {
  CulturesInTheirLanguages2["EnglishCanada"] = "English (Canada)";
  CulturesInTheirLanguages2["EnglishUnitedKingdom"] = "English (UK)";
  CulturesInTheirLanguages2["EnglishUnitedStates"] = "English (US)";
  CulturesInTheirLanguages2["EnglishAustralia"] = "English (AU)";
  CulturesInTheirLanguages2["FrenchCanada"] = "Fran\xE7ais (Canada)";
  CulturesInTheirLanguages2["FrenchFrance"] = "Fran\xE7ais (France)";
  CulturesInTheirLanguages2["SpanishSpain"] = "Espa\xF1ol (Espa\xF1a)";
  CulturesInTheirLanguages2["GermanGermany"] = "Deutsch (Deutschland)";
  CulturesInTheirLanguages2["DutchNetherlands"] = "Nederlands (Nederland)";
  CulturesInTheirLanguages2["ItalianItaly"] = "Italiano (Italia)";
  CulturesInTheirLanguages2["PortuguesePortugal"] = "Portugu\xEAs (Portugal)";
  CulturesInTheirLanguages2["SpanishMexico"] = "Espa\xF1ol (M\xE9xico)";
  CulturesInTheirLanguages2["SpanishLatinAmerica"] = "Espa\xF1ol (Am\xE9rica Latina)";
  CulturesInTheirLanguages2["StretchEnglish"] = "Stretched English";
  CulturesInTheirLanguages2["MicroCodeEnglish"] = "MicroCoded English";
  CulturesInTheirLanguages2["CroatianCroatian"] = "Hrvatski (Hrvatska)";
  CulturesInTheirLanguages2["CzechCzech"] = "\u010Ce\u0161tina (\u010Cesk\xE1 republika)";
  CulturesInTheirLanguages2["DanishDanish"] = "Dansk (Danmark)";
  CulturesInTheirLanguages2["FinnishFinish"] = "Suomi (Suomi)";
  CulturesInTheirLanguages2["HungarianHungarian"] = "Magyar (Magyarorsz\xE1g)";
  CulturesInTheirLanguages2["NorwegianBokmal"] = "Norsk Bokm\xE5l (Norge)";
  CulturesInTheirLanguages2["NorwegianNynorsk"] = "Norsk Nynorsk (Norge)";
  CulturesInTheirLanguages2["PolishPolish"] = "Polski (Polska)";
  CulturesInTheirLanguages2["SlovakSlovak"] = "Sloven\u010Dina (Slovensko)";
  CulturesInTheirLanguages2["SwedishSweden"] = "Svenska (Sverige)";
  CulturesInTheirLanguages2["SimplifiedChinese"] = "\u7B80\u4F53\u4E2D\u6587 (\u4E2D\u56FD)";
  CulturesInTheirLanguages2["JapaneseJapan"] = "\u65E5\u672C\u8A9E (\u65E5\u672C)";
  return CulturesInTheirLanguages2;
})(CulturesInTheirLanguages || {});

// src/i18n-runtime/index.ts
function isCulture(possibleCulture) {
  return CultureCodes.includes(possibleCulture);
}
var PseudoCultures = [Cultures.MicroCodeEnglish, Cultures.StretchEnglish];
function isPseudoCulture(culture) {
  return PseudoCultures.includes(culture);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CultureCodes,
  Cultures,
  CulturesInTheirLanguages,
  ICUMessageFormatter,
  PseudoCultures,
  isCulture,
  isPseudoCulture
});
//# sourceMappingURL=index.js.map
